import React from 'react';
import { testimonials } from '../../Data';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import shapeImgOne from "../../assets/images/shape-1.webp";
import shapeImgTwo from "../../assets/images/shape-2.webp";
import testimonialIcon from "../../assets/images/testimonials-icon.svg";
import "./style.scss";

const Testimonials = () => {
  return (
    <>
      <section className="testimonials section" id='testimonial'>
        <h2 className="section__title text-cs">Testimonials</h2>
        <p className="section__subtitle">
          My <span>Customers Say</span>
        </p>
        <Swiper
          slidesPerView={3}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1400: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          modules={[Pagination]} className="testimonials__container container  mySwiper">
          {testimonials.map(({ img, name, author, description }, index) => {
            return (
              <SwiperSlide className="testimonials__item card card-one" key={index}>
                <div className="testimonials__header">
                  <div className="testimonials__icon">
                    <img width="100%" 
              height="100%" loading='lazy' src={testimonialIcon} alt={`icon_${name}`} />
                  </div>
                  <img width="100%" 
              height="100%" loading='lazy' src={img} alt={`image_${img}`}  className='testimonials__img' />
                </div>

                <p className="testimonials__description">{description}</p>
                <h3 className="testimonials__name">{name}</h3>
                <p className="testimonials__author">{author}</p>

                <img width="100%" 
              height="100%" loading='lazy' src={shapeImgTwo} alt={`${img}`} className='shape c__shape' />
              </SwiperSlide>
            );
          })}
        </Swiper>

        <div className="section__deco deco__right">
          <img width="100%" 
              height="100%" loading='lazy' src={shapeImgOne} alt="shapeImg_testimonial1" className='shape' />
        </div>

        <div className="section__bg-wrapper">
          <span className="bg__title">Reviews</span>
        </div>
      </section>
    </>
  )
}

export default Testimonials;